import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { io } from 'socket.io-client';
import { Layout,notification,Button,Modal } from 'antd'; 
import CustomTable from '../../components/listComponent/ListComponent.jsx';
import AppHeader from '../../components/appHeader/AppHeader.jsx';
import './adminList.scss';
import '../../styles/responsive.scss';
import '../../styles/table-responsive.scss';
import { ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const AdminList = () => {
    const [data, setData] = useState([]);
    const [storeId, setStoreId] = useState('');
    const [token, setToken] = useState();
    const [cusId, setCusId] = useState('');
    const [cusEmail, setCusEmail] = useState('');
    const [paymentGateway, setPaymentGateway] = useState(null);
    const refreshTimerRef = useRef(null);
    const navigate = useNavigate();
    const fethcOrderList = useCallback(async () => {
      try{
      const token = sessionStorage.getItem('jwtToken'); // 从 sessionStorage 获取 JWT Token
      setToken(token);
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetch-order-list`, {},config);
      if (response.status === 200) {
      setCusEmail(response.data.storeInformation.adminEmail);
      
      setCusId(response.data.storeInformation.adminId);
      setStoreId(response.data.storeInformation.storeId);
      setPaymentGateway(response.data.storeInformation.paymentGateway);
      setData(response.data.results);}
      else {
        navigate('/qr_order/adminLogin');
      }}
      catch(error){
        navigate('/qr_order/adminLogin');
      }
    }, [navigate]);
    
  useEffect(() => {
    fethcOrderList();
  }, [fethcOrderList]);

  useEffect(() => {
    const token = sessionStorage.getItem('jwtToken');
    if (!token) return undefined;

    const socket = io(`${process.env.REACT_APP_SERVER_URL}/admin-orders`, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      auth: { token },
    });

    const scheduleRefresh = () => {
      if (refreshTimerRef.current) return;
      refreshTimerRef.current = setTimeout(() => {
        refreshTimerRef.current = null;
        fethcOrderList();
      }, 500);
    };

    socket.on('order:changed', (payload) => {
      if (!payload?.order?.OrderId) return;
      const updatedOrder = payload.order;
      setData((currentData) => {
        const existingIndex = currentData.findIndex((order) => order.OrderId === updatedOrder.OrderId);
        const nextData = existingIndex >= 0
          ? currentData.map((order) => (order.OrderId === updatedOrder.OrderId ? updatedOrder : order))
          : [updatedOrder, ...currentData];

        return [...nextData].sort((a, b) => new Date(b.OrderTime) - new Date(a.OrderTime));
      });
    });

    socket.on('order:deleted', (payload) => {
      if (!payload?.orderId) {
        scheduleRefresh();
        return;
      }
      setData((currentData) => currentData.filter((order) => order.OrderId !== payload.orderId));
    });

    socket.on('orders:refresh', () => {
      scheduleRefresh();
    });

    socket.on('admin-orders:error', () => {
      scheduleRefresh();
    });

    return () => {
      if (refreshTimerRef.current) {
        clearTimeout(refreshTimerRef.current);
        refreshTimerRef.current = null;
      }
      socket.removeAllListeners();
      socket.disconnect();
    };
  }, [fethcOrderList]);
  const handleRefresh = () => {
    fethcOrderList();
  };
  const handleResend = async(orderId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/resend-order`, {
            orderId: orderId,
            token: token
        });
        if (response.status === 200) {
         
            notification.success({
                message: 'Success',
                description: 'Order has been resent'
            });

            // 重新获取订单列表, 2s后
            setTimeout(() => {
                fethcOrderList();
            }, 3000);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to resend the order'
            });
        }
    } catch (error) {
        console.log(error);
        notification.error({
            message: 'Error',
            description: 'Failed to resend the order'
        });
    }
  };

  const handleIgnore = async(orderId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/ignore-order`, {
            orderId: orderId,
            token: token
        });
        if (response.status === 200) {
         
            notification.success({
                message: 'Success',
                description: 'Order has been ignored'
            });

            // 重新获取订单列表, 2s后
            setTimeout(() => {
                fethcOrderList();
            }, 3000);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to ignore the order'
            });
        }
    } catch (error) {
        console.log(error);
        notification.error({
            message: 'Error',
            description: 'Failed to ignore the order'
        });
    }
  };

  const handleRevoke = async(orderId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/revoke-order`, {
            orderId: orderId,
            token: token
        });
        if (response.status === 200) {
            notification.success({
                message: 'Success',
                description: 'Order has been revoked'
            });

            // 重新获取订单列表, 2s后
            setTimeout(() => {
                fethcOrderList();
            }, 3000);
        } else {
            notification.error({
                message: 'Error',
                description: 'Failed to revoke the order'
            });
        }
    } catch (error) {
        console.log(error);
        notification.error({
            message: 'Error',
            description: 'Failed to revoke the order'
        });
    }
  };

  const handleDeleteAllOrder = async () => {
    Modal.confirm({
        title: 'Are you sure?',
        content: 'This will delete all orders permanently. This action cannot be undone.',
        okText: 'Yes, delete all',
        cancelText: 'Cancel',
        onOk: async () => {
            try {
                const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT Token from sessionStorage
                const config = {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                };
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/delete-all-order`, config);
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'All orders have been deleted',
                    });

                    // Refresh order list after deletion
                    setTimeout(() => {
                        fethcOrderList();
                    }, 3000);
                } else {
                    notification.error({
                        message: 'Error',
                        description: 'Failed to delete all orders',
                    });
                }
            } catch (error) {
                console.log(error);
                notification.error({
                    message: 'Error',
                    description: 'Failed to delete all orders',
                });
            }
        },
    });
};

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <AppHeader email={cusEmail} cusId={cusId} />
    
    <div className='table_list'>
    
    <div className="page-header-actions">
      <h2>Order List</h2>
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <Button
          icon={<ReloadOutlined />}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
        {cusEmail ==='admin'&&
          <Button type="primary" onClick={handleDeleteAllOrder}>Delete All</Button>
        }
      </div>
    </div>


      <CustomTable 
        
        data={data} 
        onResend={handleResend} 
        onRevoke={handleRevoke}
        onIgnore={handleIgnore}
        onRefresh={fethcOrderList}
        storePaymentGateway={paymentGateway}
      />
    </div>
    </Layout>
  );
};

export default AdminList;
